import { Auth } from "aws-amplify";
// Note this is client-side stripe API, so you cant call things like stripe.customers.retrieve etc
import { MenuItem } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import UnsubscribeIcon from "@mui/icons-material/Unsubscribe";

import { redirect } from "react-router-dom";
import {useContext } from "react";
import { CognitoUserContext } from "../contexts/cognitoUserContext.js";
import {setCancelAtEndOfPeriod} from "../services/api/stripeService";
import {
  STRIPE_SUB_STATUS,
} from "../services/user/cognitoService";


const getAuthSessionPayload = async () => {
  try {
    const session = await Auth.currentSession();
    if (session.idToken.payload) {
      return session.idToken.payload;
    }
  } catch (error) {
  }
};



export default function PauseSubscription({ visible }) {
  const {  setCognitoUser } =
    useContext(CognitoUserContext);
  let display = visible ? "inline" : "none";
  // Handler for the button click event
  async function handleClick(e) {
    const authPayload = await getAuthSessionPayload();
    const subscriptionId = authPayload["custom:subscriptionId"];
    await setCancelAtEndOfPeriod(true, subscriptionId);
    loader();
    return redirect("/");
  }

  const loader = async () => {
    const user = await Auth.currentAuthenticatedUser({ bypassCache: true })
    user.attributes[STRIPE_SUB_STATUS]= "INACTIVE";
    setCognitoUser(user); // Update context with refreshed user attributes
    display = 'none';
  };
  
  

  return (
    <MenuItem
      sx={{ display: display }}
      onClick={handleClick}
      // this logic below is not correct for new accounts
      //disabled={NotEligibleToSubscribe()}
      variant="contained"
    >
      <Tooltip title="Pause your subscription renewal">
        <UnsubscribeIcon />
      </Tooltip>
    </MenuItem>
  );
}
